import { Button, Clickable, Strong } from '@ahmdigital/ui';
import { compact, flow, map, toInteger } from 'lodash/fp';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

import { ButtonWrapper, StyledClickable, StyledCustomerVariables, StyledSpan, StyledTooltip } from './styles';
import constants from '../../../../ahm-constants';
import getHasPartner from '../../../../pages/home/utils/get-has-partner';
import getYouthDiscountPercentageFromAges from '../../../../utils/get-youth-discount-percentage-from-ages';
import selectRebatePercentageRaw from '../../../../selectors/select-rebate-percentage-raw';
import type { RootState } from '../../../../reducers';

const { WHAT_IS_AGR } = constants.URLS.HELP;

const agrTooltip = (
  <StyledTooltip>
    The{' '}
    <Clickable to={WHAT_IS_AGR} inNewTab>
      AGR
    </Clickable>{' '}
    applied to your policy is based on the oldest member’s age on your policy.
  </StyledTooltip>
);

type FooterProps = {
  handleClose: (...args: unknown[]) => unknown;
  isProductWithHospitalServices: boolean;
};

const Footer = ({ handleClose, isProductWithHospitalServices }: FooterProps) => {
  const { submitForm, values } = useFormikContext();
  // @ts-expect-error - Automatic, Please fix when editing this file
  const { age, partnerAge, scale } = values;

  const rebatePercentage = useSelector((state: RootState) => selectRebatePercentageRaw(state, values));
  const hasPartner = getHasPartner(scale);

  const youthDiscountPercentage =
    flow(compact, map(toInteger), getYouthDiscountPercentageFromAges)([age, hasPartner && partnerAge]) || 0;

  const { YOUTH_DISCOUNT } = constants.URLS.HELP;
  const youthDiscountTooltip = (
    <StyledTooltip>
      {youthDiscountPercentage > 0 ? (
        <>
          Based on your age of {age}
          {hasPartner && partnerAge && <> and your partner’s age of {partnerAge}</>}.{' '}
        </>
      ) : (
        'Hospital price excludes any Youth Discount. '
      )}
      <Clickable to={YOUTH_DISCOUNT} inNewTab>
        Learn more about Youth Discount
      </Clickable>
    </StyledTooltip>
  );

  return (
    <>
      <StyledCustomerVariables>
        <li>
          <StyledSpan>Australian Government Rebate {agrTooltip}</StyledSpan>
          <Strong>{rebatePercentage}%</Strong>
        </li>
        {isProductWithHospitalServices && (
          <li className="youthDiscount">
            <span>Youth Discount {youthDiscountTooltip}</span>
            <Strong>{youthDiscountPercentage}%</Strong>
          </li>
        )}
      </StyledCustomerVariables>
      <ButtonWrapper>
        <StyledClickable onClick={handleClose}>Cancel</StyledClickable>
        <Button onClick={submitForm} type="submit">
          Update
        </Button>
      </ButtonWrapper>
    </>
  );
};

export default Footer;
